export default __webpack_public_path__ + "static/rguroo_logo-eb72157ad11a25e73c7089b0fbfd9952.png";